import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import styled, { useTheme } from 'styled-components';
import { sizes } from 'style';
import { th } from 'style/theme';

const MobileSvg = styled(motion.svg)`
  display: block;
  filter: drop-shadow(${th('shadows.small')});

  @media ${sizes.tabletPortrait} {
    display: none;
  }
`;

const TabletSvg = styled(motion.svg)`
  display: none;
  filter: drop-shadow(${th('shadows.small')});

  @media ${sizes.tabletPortrait} {
    display: block;
  }

  @media ${sizes.desktop} {
    display: none;
  }
`;

const DesktopSvg = styled(motion.svg)`
  display: none;

  @media ${sizes.desktop} {
    display: block;
    filter: drop-shadow(${th('shadows.small')});
  }
`;

const pathVariants = {
  small: {
    d: 'M1,1 L260.7,1 C278.271978,72.8456579 278.271978,124.620812 260.7,156.325462 C222.108732,225.954658 115.134984,159.1195 1.003,204 C1.003,204 1.003,203.957333 1.003,203.872 L1,1 Z'
  },
  large: {
    d: 'M1,1 L260.7,1 C313.004765,82.6772598 317.887079,198.677921 275.346941,349.001983 C229.320335,562.231772 361.44754,660.826896 309.6,769 C309.6,769 206.733333,769 1,769 L1,1 Z'
  }
};

const tabletPathVariants = {
  small: {
    d: 'M0,0 L770,1 L770.777757,190.448073 C685.302906,175.859114 557.13624,179.379736 386.277757,201.009938 C215.419274,222.640139 87.1044447,224.056076 1.33326981,205.257749 L0,0 Z'
  },
  large: {
    d: 'M0,0 L769,1 L770,226.244986 C692.240832,249.414995 564.074165,252.935617 385.5,236.806851 C206.925835,220.678085 78.6110059,222.094022 0.555513204,241.054662 L0,0 Z'
  }
};

const mobilePathVariants = {
  small: {
    d: 'M0,0 L376,-0.005 L376,107.026162 C307.321303,105.350552 239.79797,111.901165 173.43,126.678 C77.3222902,148.076391 30.0581412,126.678 0,114.316 C0,114.316 0,76.2106667 0,0 Z'
  },
  large: {
    d: 'M0,0 L376,-0.005 L375.365,142.533 C322.908613,165.102188 257.872557,169.676488 180.256832,156.255901 C80.5994935,139.024083 18.5157725,151.148 0,151.148 C0,151.148 0,100.765333 0,0 Z'
  }
};

const ClaimsBg = ({ variant, ...props }) => {
  const theme = useTheme();
  const color = theme.colors.turquoise;

  return (
    <>
      <MobileSvg
        width="100%"
        height="100%"
        viewBox="0 0 376 166"
        preserveAspectRatio="xMaxYMax slice"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <motion.path
            d="M0,0 L376,-0.005 L376,107.026162 C307.321303,105.350552 239.79797,111.901165 173.43,126.678 C77.3222902,148.076391 30.0581412,126.678 0,114.316 C0,114.316 0,76.2106667 0,0 Z"
            animate={variant}
            transition={{
              type: 'spring',
              stiffness: 300,
              damping: 24
            }}
            variants={mobilePathVariants}
            id="Path"
            fill={color}
          />
        </g>
      </MobileSvg>
      <TabletSvg
        width="100%"
        height="100%"
        viewBox="0 0 771 248"
        preserveAspectRatio="xMaxYMax slice"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <motion.path
            d="M0,0 L770,1 L770.777757,190.448073 C685.302906,175.859114 557.13624,179.379736 386.277757,201.009938 C215.419274,222.640139 87.1044447,224.056076 1.33326981,205.257749 L0,0 Z"
            animate={variant}
            transition={{
              type: 'spring',
              stiffness: 300,
              damping: 24
            }}
            variants={tabletPathVariants}
            id="Path"
            fill={color}
          />
        </g>
      </TabletSvg>
      <DesktopSvg
        width="100%"
        height="100%"
        viewBox="0 0 322 768"
        preserveAspectRatio="xMaxYMin slice"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <motion.path
            d="M1,1 L260.7,1 C278.271978,72.8456579 278.271978,124.620812 260.7,156.325462 C222.108732,225.954658 115.134984,159.1195 1.003,204 C1.003,204 1.003,203.957333 1.003,203.872 L1,1 Z"
            animate={variant}
            transition={{
              type: 'spring',
              stiffness: 300,
              damping: 24
            }}
            variants={pathVariants}
            id="Path"
            fill={color}
          />
        </g>
      </DesktopSvg>
    </>
  );
};

ClaimsBg.propTypes = {
  variant: PropTypes.string
};

export default ClaimsBg;
